export enum SortDirection {
  Ascending = 'ASC',
  Descending = 'DES',
}
